<template>
	<div
		:class="['content-editable-container rounded px-2', {'disabled': disabled}, {'content-error': error , 'content-editable-container--dark' : $vuetify.theme.dark }]"
	>
		<div
			contenteditable
			class="content-editable-input"
			spellcheck="false"
			ref="content-editable-input"
			@paste="checkPastedContent($event)"
			@keydown="keydownListener($event)"
			@keyup="keyupListener($event)"
			@keypress="keypressListener($event)"
			@click="showPlaceholder = false"
			v-click-outside="onClickOutside"
			:key="contentKey"
		>
		</div>
		<div
			v-if="placeholder && !content && showPlaceholder"
			class="placeholder"
		>
			{{ placeholder }}
		</div>
		<div class="content-editable-icons d-flex" >
			<template v-for="(action, i) in actions">
				<div
					v-if="action.included"
					v-bind:key="'icon-' + i"
					class="content-editable-icon ml-2"
				>
					<v-icon
						v-if="i !== 0"
						@click="action.function"
					>{{ action.icon }}</v-icon>
					<content-editable-input-emoji-picker
						v-if="i == 0"
						:icon="action.icon"
						v-model="icon"
					/>
				</div>
			</template>
		</div>
		<content-editable-mentions
			ref="content-editable-mentions"
			:mention="mention"
			:clear-mention="clearMention"
			:add-mention="addMention"
			:chat-room-users="chatRoomUsers"
		/>
	</div>
</template>

<script>
import ContentEditableInputEmojiPicker from "@/components/items/content-editable-input/ContentEditableInputEmojiPicker";
import ContentEditableMentions from "@/components/items/content-editable-input/ContentEditableMentions";
import { emojis } from "@/components/items/content-editable-input/functions/emojis";
import { mentions, mention, checkMentionsByLimit } from "@/components/items/content-editable-input/functions/mentions";
import { encodeCommentValue } from "@/components/items/content-editable-input/functions/helpers";
import { decodeMentions } from "@/functions/mentions";
export default {
	name: "ContentEditableInput",
	watch: {
		icon(v) {
			if (v) {
				this.content = true;
				this.hideEmojiPicker()
				emojis(v, this.$refs['content-editable-input'])
				this.$emit('input', encodeCommentValue(this.$refs['content-editable-input']))
			}
		},
		disabled(v) {
			if(v) {
				this.$refs['content-editable-input'].blur();
			}
			setTimeout(() => {
				this.$refs['content-editable-input'].tabIndex = 0;
				this.$refs['content-editable-input'].focus();
			}, 300)
		},
		images() {
			console.log("KEY!!")
		}
	},
	components: {
		ContentEditableInputEmojiPicker,
		ContentEditableMentions
	},
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		chatRoomUsers: {
			required: false,
			type: Array,
		},
		error: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String
		},
		emojis: {
			type: Boolean,
			default: false
		},
		attachments: {
			type: Boolean,
			default: false
		},
		images: {
			type: Boolean,
			default: false
		},
		enterPress: {
			type: Function,
			default: null
		},
		escapePress: {
			type: Function,
			default: null
		},
		height: {
			type: Number,
			default: null
		},
		newLineOnEnter: {
			type: Boolean,
			default: false
		},
		maxLength: {
			type: Number,
			default: function () {
				return this.$store.state.validation.post.content
			}
		},
		contentKey: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			content: false,
			showPlaceholder: true,
			icon: null,
			mention: null,
			emojiPickerDisplay: false,
		}
	},
	mounted() {
		if (this.$attrs && this.$attrs.value && (this.$attrs.value.content || this.$attrs.value.mention_users)) {
			if(this.$attrs.value.mention_users && this.$attrs.value.mention_users.length) {
				this.$refs['content-editable-input'].innerHTML = decodeMentions(this.$attrs.value.content, this.$attrs.value.mention_users);
			}
			else {
				this.$refs['content-editable-input'].innerHTML = this.$attrs.value.content;
			}
		}
		else {
			this.$emit('input', encodeCommentValue(this.$refs['content-editable-input']))
		}
		this.checkContent()

		// console.log("THIS WILL EMIT",  encodeCommentValue(this.$refs['content-editable-input']))

		setTimeout(() => {
			this.calculateContenteditableWidth()
		}, 300)

	},
	computed: {
		actions() {
			return [
				{
					icon: '$face',
					function: this.openEmojiPicker,
					included: this.emojis
				},
				{
					icon: '$photo',
					function: this.addImage,
					included: this.images
				},
				{
					icon: '$file-add',
					function: this.addAttachment,
					included: this.attachments
				},
			]
		}
	},
	methods: {
		clear() {
			let element = this.$refs['content-editable-input'];
			element.innerHTML = '';
		},
		setFocus() {
			let element = this.$refs['content-editable-input'];
			setTimeout(function(){
				console.log("FOCUS ON", element);
				element.click();
			}, 500);
		},
		/* eslint-disable */
		checkPastedContent(e) {
			e.preventDefault()
			let text = (e.originalEvent || e).clipboardData.getData('text/plain')
			document.execCommand("insertHTML", false, text.replaceAll('\n', '<br>'))
			checkMentionsByLimit(this.$refs['content-editable-input'], this.maxLength)
			this.$emit('input', encodeCommentValue(this.$refs['content-editable-input']))
		},
		checkContent() {
			this.content = !!this.$refs['content-editable-input'].innerHTML
		},
		onClickOutside() {
			this.showPlaceholder = true;
		},
		clearComment() {
			this.$refs['content-editable-input'].innerHTML = ''
		},
		keypressListener(e) {
			if (e.keyCode === 13) {
				e.preventDefault()
				if (this.newLineOnEnter || (!this.newLineOnEnter && e.shiftKey))
					document.execCommand("insertLineBreak")
			}
		},
		keydownListener(e) {
			if(this.disabled) {
				e.preventDefault();
				return;
			}
			if (this.mention) {
				if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
					e.preventDefault()
					if (e.key === 'ArrowUp') {
						this.$refs['content-editable-mentions'].goUp()
					} else if (e.key === 'ArrowDown') {
						this.$refs['content-editable-mentions'].goDown()
					}
				}
			} else {
				// console.clear()
				// console.log(e)
				// console.dir(e.target.innerText.length)
				if (e.target.innerText.length >= this.maxLength && (e.key === ' ' || (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 97 && e.keyCode <= 122)))
					e.preventDefault()
				if (!this.newLineOnEnter && e.key === 'Enter' && !e.shiftKey) {
					e.preventDefault();
					this.$emit('enterPress')
				}

				if (e.key === 'Escape')
					this.$emit('escapePress')
			}
		},
		keyupListener(e) {
			if(this.disabled) {
				e.preventDefault();
				return;
			}
			if (this.mentionCheckDelayer) {
				clearTimeout(this.mentionCheckDelayer);
				this.mentionCheckDelayer = null
			}
			this.mentionCheckDelayer = setTimeout(() => {
				if (!this.mention || (this.mention && e.key !== 'ArrowUp' && e.key !== 'ArrowDown') && e.key !== 'Enter') {
					this.mention = mentions(this.$refs['content-editable-input'])
				}
				this.checkContent();
				this.$emit('input', encodeCommentValue(this.$refs['content-editable-input']))
			}, 0);
		},
		openEmojiPicker() {
			this.emojiPickerDisplay = true
		},
		hideEmojiPicker() {
			this.emojiPickerDisplay = false
			this.icon = null
		},
		addImage() {
			this.$emit('addImage')
		},
		addAttachment() {
			this.$emit('addAttachments');
		},
		clearMention() {
			this.mention = null
		},
		addMention(user) {
			this.mention.user = user
			mention(this.$refs['content-editable-input'], this.mention)
			this.mention = null
			this.$emit('input', encodeCommentValue(this.$refs['content-editable-input']))
		},
		calculateContenteditableWidth() {
			if(this.$refs['content-editable-input']) {
				let element = this.$refs['content-editable-input'].parentElement,
					style = getComputedStyle(element),
					elWidth = element.clientWidth
				elWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
				if (this.emojis)
					elWidth -= 28
				if (this.attachments)
					elWidth -= 28
				if (this.images)
					elWidth -= 28
				this.$refs['content-editable-input'].style.width = elWidth + 'px'
				this.$refs['content-editable-input'].style.minHeight = (this.height) ? (this.height + 'px') : 'unset'
			}
		}
	}
}
</script>

<style lang="scss">
.content-editable-container {
	border: 1px solid;
	padding-top: 10px;
	padding-bottom: 10px;
	&:not(&--dark) {
		border-color: var(--v-grey-lighten4);
	}
	&--dark {
		border-color: var(--v-grey-lighten3);
	}
	&.content-error {
		.placeholder {
			color: var(--v-error-base);
		}
		border-color: var(--v-error-base);
	}
	position: relative;
	.content-editable-input {
		display: block;
		outline: none !important;
		resize: none;
		overflow: hidden;
		white-space: pre-wrap;
	}
	.content-editable-icons {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1;
		> div {
			cursor: pointer;
		}
	}

	.placeholder {
		pointer-events: none;
		position: absolute;
		left: 3;
		color: var(--v-grey-base)
	}
}
</style>
